import { render, staticRenderFns } from "./MaterialTemplateEditPage.vue?vue&type=template&id=4e8a0bb5&scoped=true&"
import script from "./MaterialTemplateEditPage.vue?vue&type=script&lang=ts&"
export * from "./MaterialTemplateEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialTemplateEditPage.vue?vue&type=style&index=0&id=4e8a0bb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a0bb5",
  null
  
)

export default component.exports